import Utils from "../../../utility";

const initialState = {
  storeGRNList: [],
  GRNDetail: {},
  id: 0,
  type: "",
  order: "DESC",
  // sortField: "",
  offset: 1,
  take: 20,
  search: "",
  count: 0,
  oprationManagerList: [],
  billerList: [],
};
export const storeGRNReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${Utils.ActionName.STORE_GRN}`:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
};
